import { render, staticRenderFns } from "./FeYeyi.vue?vue&type=template&id=081a945f&"
import script from "./FeYeyi.vue?vue&type=script&lang=js&"
export * from "./FeYeyi.vue?vue&type=script&lang=js&"
import style0 from "./FeYeyi.vue?vue&type=style&index=0&id=081a945f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports